module.exports = __webpack_public_path__ + "img/home_pic_ad.b40fe376.png";